function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  font-size: inherit;\n\n  &:checked {\n    & + ", " {\n      background: ", ";\n      border-radius: 50%;\n\n      &::after {\n        display: block;\n        border-color: ", ";\n      }\n    }\n  }\n\n  &:focus + ", "::before {\n    display: block;\n    height: 1rem;\n    width: 1rem;\n    top: -0.75rem;\n    left: -0.75rem;\n    border-radius: 50%;\n    border-style: solid;\n    border-width: 0.75rem;\n    animation: highlight 2s linear;\n    background-color: ", ";\n    opacity: 0;\n  }\n\n  @keyframes highlight {\n    0% {\n      border-color: ", ";\n      opacity: 0;\n    }\n    12% {\n      border-color: ", ";\n      opacity: 0.1;\n    }\n    25% {\n      border-color: ", ";\n      opacity: 0.15;\n    }\n    50% {\n      border-color: ", ";\n      opacity: 0.25;\n    }\n    75% {\n      border-color: ", ";\n      opacity: 0.15;\n    }\n    87% {\n      border-color: ", ";\n      opacity: 0.1;\n    }\n    100% {\n      border-color: ", ";\n      opacity: 0;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0.75rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 1rem;\n  height: 1rem;\n  background: ", ";\n  cursor: pointer;\n  transition: background 0.3s;\n\n  &::before {\n    content: '';\n    position: absolute;\n    display: none;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    display: block;\n    border: 0.0625rem solid ", ";\n    border-radius: 50%;\n    height: calc(1rem - 2px);\n    width: calc(1rem - 2px);\n    top: 0;\n    left: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  text-align: left;\n  cursor: pointer;\n  user-select: none;\n  height: 2.5rem;\n  line-height: 1rem;\n  padding-left: 2.75rem;\n  font-size: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";
export var RadioLabel = styled.label(_templateObject(), function (props) {
  return props.theme.variables.fonts.size.base;
}, function (props) {
  return props.theme.variables.typography.primaryFont;
}, function (props) {
  return props.theme.variables.fonts.weight.regular;
});
export var RadioMark = styled.span(_templateObject2(), function (props) {
  return props.theme.variables.colors.white;
}, function (props) {
  return props.theme.variables.colors.midGrey;
});
export var RadioInput = styled.input(_templateObject3(), RadioMark, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.colors.blue;
}, RadioMark, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.colors.white;
}, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.colors.white;
});